import { interventionServices } from '@/services/db';

const state = {
  interventions: [],
  intervention: {},
};

const getters = {
  allInterventions: (state) => state.interventions,
  interventionById: (state) => (id) => {
    return state.interventions.find((intervention) => intervention.id === id);
  },
  getIntervention: (state) => state.intervention,
};

const mutations = {
  SET_INTERVENTIONS(state, interventions) {
    state.interventions = interventions;
  },
  SET_INTERVENTION(state, intervention) {
    state.intervention = intervention;
  },
};

const actions = {
  async fetchInterventions({ commit }) {
    try {
      const interventions = await interventionServices.fetchInterventions();
      commit('SET_INTERVENTIONS', interventions);
    } catch (error) {
      console.error('Error fetching interventions:', error);
    }
  },
  async fetchIntervention({ commit }, id) {
    try {
      const intervention = await interventionServices.getIntervention(id);
      commit('SET_INTERVENTION', intervention);
    } catch (error) {
      console.error(`Error fetching intervention with id ${id}:`, error);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
